import { RouterState, EnterHook } from 'react-router';

import { Language } from '@ha/intl';
import { PricingUrls } from 'ha/constants/PricingPageSlug';

const redirectedRoutes = [
  {
    path: 'faq',
    getNextPath: () => '/answers',
  },
  {
    path: '/university-plans',
    getNextPath: () => '//info.housinganywhere.com/universities',
  },
  {
    path: 'unsubscribe',
    getNextPath: () => '/my/subscriptions',
  },
  {
    path: 'search/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/s/${
        nextState.params.splat
      }`,
  },
  {
    path: 'hello/*',
    getNextPath: (nextState: RouterState) => `/h/${nextState.params.splat}`,
  },
  {
    path: '/admin/conversation',
    getNextPath: (nextState: RouterState) =>
      `/admin/conversations/${nextState.location.query.cid}`,
  },
  {
    path: 'city/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/${
        nextState.params.splat
      }`,
  },
  {
    path: '/my/payment-form',
    getNextPath: (nextState: RouterState) =>
      `/my/talk/${nextState.location.query.id}/book`,
  },
  {
    path: 'how-to-list',
    getNextPath: () => '/become-an-advertiser',
  },
  {
    path: 'about',
    getNextPath: () => '/',
  },
  // We don't have PT and ZH in contenfull, but CTA on Home page in these languages leads to 404
  // We might remove that page in the future at all, so far we set redirects to EN
  {
    path: '/pt/become-an-advertiser',
    getNextPath: () => '/become-an-advertiser',
  },
  {
    path: '/zh/become-an-advertiser',
    getNextPath: () => '/become-an-advertiser',
  },
  {
    path: '/nl/become-an-advertiser',
    getNextPath: () => '/nl/verhuurder-worden',
  },
  {
    path: '/fr/become-an-advertiser',
    getNextPath: () => '/fr/devenir-annonceur',
  },
  {
    path: '/es/become-an-advertiser',
    getNextPath: () => '/es/hazte-anunciante',
  },
  {
    path: '/it/become-an-advertiser',
    getNextPath: () => '/it/dai-in-affitto',
  },
  {
    path: '/de/become-an-advertiser',
    getNextPath: () => '/de/inserent-werden',
  },
  // temporarily redirect old payment-methods route to the new one
  {
    path: '/my/payment-methods',
    getNextPath: () => '/my/payments/methods',
  },
  {
    path: '/my/payment-requests',
    getNextPath: () => '/my/payouts/payment-requests',
  },
  {
    path: '/how-to-book',
    getNextPath: () => '/renting',
  },
  {
    path: '/pricing',
    getNextPath: () => '/pricing/tenants',
  },
  {
    path: '/nl/Nederland/verhuren-van-vastgoed',
    getNextPath: () => '/nl/Nederland/woning-verhuren',
  },
  {
    path: '/de/vermietung',
    getNextPath: () => '/de/Deutschland/vermietung',
  },
  {
    path: '/rentradar',
    getNextPath: () => 'https://rentradar.housinganywhere.com/',
  },
  {
    path: 'agb',
    getNextPath: () => '/terms',
  },
  {
    path: '/nl/pricing/tenants',
    getNextPath: () => `/nl${PricingUrls.tenant.nl}`,
  },
  {
    path: '/de/pricing/tenants',
    getNextPath: () => `/de${PricingUrls.tenant.de}`,
  },
  {
    path: '/es/pricing/tenants',
    getNextPath: () => `/es${PricingUrls.tenant.es}`,
  },
  {
    path: '/fr/pricing/tenants',
    getNextPath: () => `/fr${PricingUrls.tenant.fr}`,
  },
  {
    path: '/it/pricing/tenants',
    getNextPath: () => `/it${PricingUrls.tenant.it}`,
  },
  {
    path: '/pt/pricing/tenants',
    getNextPath: () => `/pt${PricingUrls.tenant.pt}`,
  },
  {
    path: '/zh/pricing/tenants',
    getNextPath: () => PricingUrls.tenant.zh,
    redirectCode: 302,
  },
  {
    path: '/nl/pricing/landlords',
    getNextPath: () => `/nl${PricingUrls.landlord.nl}`,
  },
  {
    path: '/de/pricing/landlords',
    getNextPath: () => `/de${PricingUrls.landlord.de}`,
  },
  {
    path: '/es/pricing/landlords',
    getNextPath: () => `/es${PricingUrls.landlord.es}`,
  },
  {
    path: '/fr/pricing/landlords',
    getNextPath: () => `/fr${PricingUrls.landlord.fr}`,
  },
  {
    path: '/it/pricing/landlords',
    getNextPath: () => `/it${PricingUrls.landlord.it}`,
  },
  {
    path: '/pt/pricing/landlords',
    getNextPath: () => `/pt${PricingUrls.landlord.pt}`,
  },
  {
    path: '/zh/pricing/landlords',
    getNextPath: () => PricingUrls.landlord.zh,
    redirectCode: 302,
  },

  {
    path: '/Germany/health-insurance',
    getNextPath: () => '/Germany/health-insurance-in-germany',
  },
  {
    path: '/Germany/practical-info-for-living',
    getNextPath: () => '/Germany/living-in-germany',
  },
  {
    path: '/top-internships-germany',
    getNextPath: () => '/Germany/top-internships-germany',
  },
  {
    path: '/Rotterdam--Netherlands/accommodation',
    getNextPath: () => '/s/Rotterdam--Netherlands',
    redirectCode: 301,
  },
  {
    path: '/fr/Rotterdam--Pays~Bas/logement',
    getNextPath: () => '/fr/s/Rotterdam--Pays~Bas',
    redirectCode: 301,
  },
  {
    path: '/de/Rotterdam--Niederlande/Unterkunft',
    getNextPath: () => '/de/s/Rotterdam--Niederlande',
    redirectCode: 301,
  },
  {
    path: '/es/R%C3%B3terdam--Holanda/alojamiento',
    getNextPath: () => '/es/s/Róterdam--Holanda',
    redirectCode: 301,
  },
  {
    path: '/it/Rotterdam--Olanda/sistemazione',
    getNextPath: () => '/it/s/Rotterdam--Olanda',
    redirectCode: 301,
  },
  {
    path: '/nl/Rotterdam--Nederland/Kamers',
    getNextPath: () => '/nl/s/Rotterdam--Nederland',
    redirectCode: 301,
  },
  {
    path: '/:city--:country/accommodation',
    getNextPath: (nextState: RouterState) => {
      const { city, country } = nextState.params;

      return `/s/${city}--${country}`;
    },
    redirectCode: 301,
  },
  {
    path: 'countries/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/${
        nextState.params.splat
      }`,
  },
  {
    path: 'lander/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/${
        nextState.params.splat
      }`,
  },
  {
    path: 'paises/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/${
        nextState.params.splat
      }`,
  },
  {
    path: 'pays/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/${
        nextState.params.splat
      }`,
  },
  {
    path: 'paesi/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/${
        nextState.params.splat
      }`,
  },
  {
    path: 'landen/*',
    getNextPath: (nextState: RouterState) =>
      `${nextState.params.lang ? `/${nextState.params.lang}` : ''}/${
        nextState.params.splat
      }`,
  },
  {
    path: '/my/payouts/verify-identity/*',
    getNextPath: () => '/my/payouts/verify-identity',
  },
];

const commissionRedirects = Object.keys(Language).map(lang => ({
  path: `${lang === Language.en ? '' : lang}/faq-commission`,
  getNextPath: () =>
    `${lang === Language.en ? '' : `/${lang}`}/pricing/landlords`,
}));

redirectedRoutes.push(...commissionRedirects);

export const onEnterUserProfile: EnterHook = (
  { location, params },
  replace,
  callback,
) => {
  replace({
    pathname: `/users/show/${params.userID}`,
    search: location.search,
    query: location.query,
    state: location.state,
  });

  if (callback) {
    callback();
  }
};

export const onEnterRoomPage: EnterHook = (
  { location, params },
  replace,
  callback,
) => {
  replace({
    pathname: `/room/${params.splat}`,
    search: location.search,
    query: location.query,
    state: location.state,
  });

  if (callback) {
    callback();
  }
};

export default redirectedRoutes.map(({ path, getNextPath, redirectCode }) => {
  const onEnter: EnterHook = (nextState, replace, callback) => {
    const { search, query, state } = nextState.location;

    replace({
      pathname: getNextPath(nextState),
      search,
      query,
      state: { ...state, redirectCode },
    });

    if (callback) {
      callback();
    }
  };

  return { path, onEnter };
});
